import axios, { AxiosError, AxiosResponse } from 'axios';
import { parseAxiosError } from '../common/constant';
import { BASEURL, OPENPROJECT_LOGIN_UI_BASEURL } from './const';
import moment from 'moment';

const openProjectApi = axios.create()
/* HTTP Request Interceptor to add headers on all API calls */
openProjectApi.interceptors.request.use(
    config => {

        const openProjectAccessToken = localStorage.getItem('openProjectAccessToken') || "";
        const access_token = openProjectAccessToken.replace(/"/g, "");
        if (!access_token) {
            return Promise.reject("User don't have jira access");
        }
        const token = sessionStorage.getItem('id');
        config.headers['x-api-key'] = token
        config.headers['apikey'] = `Bearer ${access_token}`;
        return config;
    },
    error => {
        Promise.reject(error);
    }
)

/* HTTP Response Interceptor to redirect to not found page when 401 HTTP Code Received */
openProjectApi.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return Promise.reject(error)
    }
)

export const getRedirectUrl = async (): Promise<any> => {
    try {
        const response = await axios.get(`${OPENPROJECT_LOGIN_UI_BASEURL}/openproject/redirect-url`);
        console.log("REDIRECT_URL_RESP", response.data)
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const getToken = async (code: string): Promise<any> => {
    try {
        // const response = await axios.get(`${BASEURL}/openproject/get-token?code=${code}`);
        const response = await axios.get(`${OPENPROJECT_LOGIN_UI_BASEURL}/openproject/get-token?code=${code}`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const validateUser = async (token: string): Promise<any> => {
    try {
        const response = await axios.get(`${OPENPROJECT_LOGIN_UI_BASEURL}/openproject/self`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const getAccessToken = async (token: string): Promise<any> => {
    try {
        const refreshToken = token.replace(/"/g, "")
        const response = await axios.post(`${BASEURL}/openproject/refresh-token`, { refresh_token: refreshToken })
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const refreshOpenProjectToken = async () => {
    try {
        console.log("[TESTING] Op Calling refresh token at" + moment(new Date()).format('YYYY-MM-DD HH:mm:ss'));
        const openProjectRefreshToken = localStorage.getItem('openProjectRefreshToken') || ""
        if (!openProjectRefreshToken) {
            throw new Error("Open Project Refresh Token not found")
        }
        const refreshToken = openProjectRefreshToken.replace(/"/g, "")
        const response = await openProjectApi.post(`${BASEURL}/openproject/refresh-token`, { refresh_token: refreshToken })
        const { refresh_token, access_token } = response?.data?.data || {}
        localStorage.setItem('openProjectAccessToken', JSON.stringify(access_token));
        localStorage.setItem('openProjectRefreshToken', JSON.stringify(refresh_token));
        return true;
    } catch (error) {
        return parseAxiosError(error as AxiosError);
    }
}

/* to get the list of work packages types */
export const getOpenProjectTypes = async (): Promise<any> => {
    try {
        const response = await openProjectApi.get(`${BASEURL}/openproject/types`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

/* to get the list of projects */
export const getOpenProjectAllProjects = async (): Promise<any> => {
    try {
        const response = await openProjectApi.get(`${BASEURL}/openproject/projects`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

/* to get the list of tasks */
export const getOpenProjectAllTask = async (): Promise<any> => {
    try {
        const response = await openProjectApi.get(`${BASEURL}/openproject/tasks`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const getOpenProjectUsers = async (): Promise<any> => {
    try {
        const response = await openProjectApi.get(`${BASEURL}/openproject/users`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const searchOpenProjectUser = async (name: string): Promise<any> => {
    try {
        const response = await openProjectApi.get(`${BASEURL}/openproject/users-list?text=${name}`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

/* to get the list of tasks of the user */

interface getOpenProjectAllUserTaskParam {
    ldapUserId: string,
    startDate: string,
    reporter?: string,
    endDate: string,
    filterIssueTypeId?: string,
    filterIssueCompleteShow?: boolean,
    searchIssueText?: string,
    signal?: AbortSignal,
    showCompleted?: boolean,
    showPending?: boolean,
    createdBy?: boolean,
    allOpen?: boolean,
    recentlyCreated?: boolean,
    overDue?: boolean,
}
export const getOpenProjectAllUserTask = async ({ ldapUserId, startDate, endDate, filterIssueTypeId, filterIssueCompleteShow, searchIssueText, signal, reporter, showCompleted, showPending, createdBy, allOpen, recentlyCreated, overDue }: getOpenProjectAllUserTaskParam): Promise<any> => {
    try {
        const response = await openProjectApi.get(
            `${BASEURL}/openproject/tasks`,
            {
                signal,
                params: {
                    id: ldapUserId,
                    type: filterIssueTypeId,
                    showClosed: filterIssueCompleteShow,
                    text: searchIssueText,
                    startDate,
                    endDate,
                    reporter,
                    showCompleted,
                    showPending,
                    createdBy,
                    allOpen,
                    recentlyCreated,
                    overDue,
                }
            }
        );
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

/* to get the list of projects of the user */
export const getOpenProjectUserProjects = async ({ membershipLink }: { membershipLink: string }): Promise<any> => {
    try {
        const response = await openProjectApi.get(`${BASEURL}/openproject/project-details?link=${membershipLink}`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

/* to get the list of tasks of a project */
interface getOpenProject_ProjectTasksParam {
    ldapUserId: string,
    workPackagesLink: string,
    filterIssueTypeId?: string,
    filterIssueCompleteShow?: boolean,
    searchIssueText: string,
    startDate: string,
    endDate: string
    signal?: AbortSignal
    reporter?: string,
    showCompleted?: boolean,
    showPending?: boolean,
    createdBy: boolean,
    allOpen: boolean,
    recentlyCreated: boolean,
    overDue: boolean,
}
export const getOpenProject_ProjectTasks = async ({ ldapUserId, workPackagesLink, filterIssueTypeId, filterIssueCompleteShow, searchIssueText, startDate, endDate, signal, reporter, showCompleted, showPending, createdBy, allOpen, recentlyCreated, overDue }: getOpenProject_ProjectTasksParam): Promise<any> => {
    try {
        const response = await openProjectApi.get(
            `${BASEURL}/openproject/project-details`,
            {
                signal,
                params: {
                    id: ldapUserId,
                    link: workPackagesLink,
                    type: filterIssueTypeId,
                    showClosed: filterIssueCompleteShow,
                    text: searchIssueText,
                    startDate,
                    endDate,
                    reporter,
                    showCompleted,
                    showPending,
                    createdBy,
                    allOpen,
                    recentlyCreated,
                    overDue,
                }
            }
        );
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

interface getOpenProjectFilteredTasksParam {
    id: string,
    createdBy: boolean,
    allOpen: boolean,
    recentlyCreated: boolean,
    overDue: boolean,
}
export const getOpenProjectFilteredTasks = async ({ id, createdBy, allOpen, recentlyCreated, overDue }: getOpenProjectFilteredTasksParam): Promise<any> => {
    try {
        const response = await openProjectApi.get(
            `${BASEURL}/openproject/task-filter`,
            {
                params: {
                    id,
                    createdBy,
                    allOpen,
                    recentlyCreated,
                    overDue,
                }
            }
        );
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}



export const getOpenProjectIssueStatuses = async (): Promise<any> => {
    try {
        const response = await openProjectApi.get(`${BASEURL}/openproject/statuses`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const createOpenProjectTask = async (data: any) => {
    try {
        const response = await openProjectApi.post(`${BASEURL}/openproject/project-details`, data)
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const loggingOpenProjectTaskTrackedTime = async (data: any) => {
    try {
        const response = await openProjectApi.post(`${BASEURL}/openproject/add-work-log`, data)
        return response?.data;

    } catch (error) {
        return parseAxiosError(error as AxiosError);
    }
}

export const updateOpenProjectTask = async (data: any) => {
    try {
        const response = await openProjectApi.patch(`${BASEURL}/openproject/project-details`, data)
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const addOpenProjectComment = async (data: any) => {
    try {
        const response = await openProjectApi.post(`${BASEURL}/openproject/comments`, data)
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

interface addMeetingTaskInOpenProjectParam {
    issueKey: string
    title: string
    meetingWith: string
    notes: string
}
export const addMeetingTaskInOpenProject = async (data: addMeetingTaskInOpenProjectParam) => {
    try {
        const response = await openProjectApi.post(`${BASEURL}/openproject/create-meet`, data);
        return response?.data;

    } catch (error) {
        return parseAxiosError(error as AxiosError);
    }
}

interface updateMeetingTaskInOpenProjectParam {
    issueId: string,
    formData: FormData
}
export const updateMeetingTaskInOpenProject = async ({ issueId, formData }: updateMeetingTaskInOpenProjectParam) => {
    try {
        const response = await openProjectApi.post(`${BASEURL}/openproject/task/${issueId}/video-upload`,
            formData,
            {
                headers: { 'Content-Type': 'multipart/form-data', }
            }
        )
        return response?.data;

    } catch (error) {
        return parseAxiosError(error as AxiosError);
    }
}

export const syncTimeWithOpenProject = async (userId: string) => {
    try {
        const response = await openProjectApi.get(`${BASEURL}/openproject/sync-log`, {
            params: {
                userId,
            }
        });
        return response?.data;
    } catch (error) {
        return parseAxiosError(error as AxiosError);
    }
}

export const getOpenProjectTrackedTime = async (userId: string, admin: boolean) => {
    try {
        const response = await openProjectApi.get(`${BASEURL}/openproject/log-time`, {
            params: {
                userId,
                isAdmin: admin
            }
        });
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const getOpenProjectAssignee = async (projectId: string) => {
    try {
        const response = await openProjectApi.get(`${BASEURL}/openproject/assignee-list`, {
            params: {
                projectId
            }
        });
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const getOpenProjectComments = async (issueKey: string) => {
    try {
        const response = await openProjectApi.get(`${BASEURL}/openproject/get-comments/${issueKey}`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const getUserNotification = async () => {
    try {
        const response = await openProjectApi.get(`${BASEURL}/openproject/user-notifications`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const readUserNotification = async (notificationId: string) => {
    try {
        const response = await openProjectApi.get(`${BASEURL}/openproject/notifications-read?id=${notificationId}`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const getCommentDetails = async (activityId: string) => {
    try {
        const response = await openProjectApi.get(`${BASEURL}/openproject/notification/comment-details/${activityId}`);
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}

export const addNewProject = async (data: any) => {
    try {
        const response = await openProjectApi.post(`${BASEURL}/openproject/projects`, data);
        return response?.data;
    } catch (error) {
        return parseAxiosError(error as AxiosError);
    }
}

export const getOpenProjectLinksRes = async <TResData = any>({
  href,
}: {
  href: string;
}) => {
  try {
    const response: AxiosResponse<TResData> = await openProjectApi.get(
      `${BASEURL}/_links`,
      {
        params: {
          href,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return parseAxiosError(error as AxiosError);
  }
};